module.exports = "/_next/static/images/text-blue-num-2-ac7f413c.png";